import { get, post, put, del, postBlob } from "@/utils/api";

export const ItemAPI = {
    query: async (params) => {
        return await get("/item", params);
    },
    getNonInventoryItems: async (type) => {
        return await get("/item/non-inventory");
    },
    get: async (id) => {
        return await get(`/item/${id}`);
    },
    add: async (params) => {
        return await put("/item", params);
    },
    update: async (id, params) => {
        return await post(`/item/${id}`, params);
    },
    active: async (id) => {
        return await post(`/item/${id}/1`);
    },
    close: async (id) => {
        return await post(`/item/${id}/2`);
    },
    getDocuments: async (id) => {
        return await get("/item/document", { itemId: id });
    },
    addDocument: async (id, file) => {
        return await post(`/item/document?itemId=${id}`, { file: file });
    },
    updateDocument: async (id, params) => {
        return await post(`/item/document/${id}`, params);
    },
    deleteDocument: async (id) => {
        return await del(`/item/document/${id}`)
    },

    actives: async () => {
        return await get("/item/actives");
    },
}

export const InventoryAPI = {
    getItems: async (params) => {
        return await get("/inventory", params)
    },
    receivedItems: async (params) => {
        return await get("/inventory/received-items", params);
    },
    stock: async (itemId) => {
        return await get("/inventory/stock", { itemId: itemId });
    },
    getItemCommitted: async (itemId) => {
        return await get(`/inventory/item/${itemId}/committed`);
    },
    getItemOnOrder: async (itemId) => {
        return await get(`/inventory/item/${itemId}/on-order`);
    },
    lots: async (params) => {
        return await get("/inventory/lots", params);
    },
    itemFulfilledLots: async (itemId) => {
        return await get(`/inventory/item/${itemId}/fulfilled-lots`);
    },
    evaluation: async (page, params) => {
        return await get("/inventory/evaluation", { page, ...params });
    },
    exportData: async (params) => {
        return await postBlob("/inventory/export", params);
    },
    itemInventories: async (itemIds) => {
        return await get("/inventory/item", { itemIds: itemIds });
    },
    exportItemInventory: async (params) => {
        return await postBlob("/inventory/item-inventory/export", params);
    },
    itemInventoryByWarehouse: async (itemId, warehouseId) => {
        return await get(`/inventory/item/${itemId}/warehouse/${warehouseId}/available`);
    },
    itemInventoryAvailable: async (itemId) => {
        return await get(`/inventory/item/${itemId}/available`);
    }
}

export const WarehouseAPI = {
    query: async (page, params) => {
        const criteria = { page: page, status: params.status };
        return await get("/warehouse", criteria)
    },
    get: async (id) => {
        return await get(`/warehouse/${id}`);
    },
    add: async (values) => {
        return await put("/warehouse", values);
    },
    update: async (id, values) => {
        return await post(`/warehouse/${id}`, values);
    },
    enable: async (id) => {
        return await post(`/warehouse/${id}/1`);
    },
    disable: async (id) => {
        return await post(`/warehouse/${id}/2`);
    },
    actives: async (includeUnavailable = false) => {
        return await get("/warehouse/actives", { includeUnavailable });
    },
    getLocations: async (id, page) => {
        return await get(`/warehouse/${id}/locations`, { page: page })
    },
    activeLocations: async (id, name) => {
        return await get(`/warehouse/${id}/location/actives`, { locationName: name })
    },
    locations: async (id, name) => {
        return await get(`/warehouse/${id}/locations`, { locationName: name })
    },
    addLocation: async (id, params) => {
        return await put(`/warehouse/${id}/location`, params);
    },
    updateLocation: async (id, locationId, params) => {
        return await post(`/warehouse/${id}/location/${locationId}`, params);
    },
    deleteLocation: async (id, locationId) => {
        return await del(`/warehouse/${id}/location/${locationId}`);
    },
    uploadLocations: async (id, file) => {
        return await post(`/warehouse/${id}/locations`, { file: file })
    },
}

export const InvAdjustmentOrderAPI = {
    query: async (params) => {
        return await get("/inv-adjustment-order", params);
    },
    get: async (id) => {
        return await get(`/inv-adjustment-order/${id}`);
    },
    add: async (params) => {
        return await put("/inv-adjustment-order", params);
    },
}

export const InvMovementOrderAPI = {
    query: async (params) => {
        return await get("/inv-movement-order", params);
    },
    get: async (id) => {
        return await get(`/inv-movement-order/${id}`);
    },
    add: async (params) => {
        return await put("/inv-movement-order", params);
    },
}
